var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#shopping-list--U1RlZ';
                    var viewUrl = 'sprites.svg#view-shopping-list--U1RlZ';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };